module.exports = __webpack_public_path__ + "media/bootstrap-icons/binoculars-fill-c48ed3a7.svg";